import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ErrorPageComponent } from './shared-resources/components/error-page/error-page.component';
import { HomeComponent } from './shared-resources/components/home/home.component';
import { WelcomeComponent } from './shared-resources/components/welcome/welcome.component';


const routes: Routes = [
  { path: '', redirectTo: '/portal', pathMatch: 'full' },
  {
    path: 'welcome',
    component: WelcomeComponent,
  },
  {
    path: 'portal', component: HomeComponent,
    children: [
      {
        path: 'personal-info',
        loadChildren: () => import('./personal-info/personal-info.module').then(m => m.PersonalInfoModule)
      },
      {
        path: 'website-account',
        loadChildren: () => import('./website-account/website-account/website-account.module').then(m => m.WebsiteAccountModule)
      },
      {
        path: 'manage-website-listings',
        loadChildren: () => import('./manage-website-listings/manage-website-listings.module').then(m => m.ManageWebsiteListingsModule)
      },
      {
        path: 'subscriptions',
        loadChildren: () => import('./subscriptions/subscriptions/subscriptions.module').then(m => m.SubscriptionsModule)
      },
      {
        path: 'website-listing',
        loadChildren: () => import('./website-listing/website-listing/website-listing.module').then(m => m.WebsiteListingModule)
      },
      {
        path: 'team-website',
        loadChildren: () => import('./team-website/team-website.module').then(m => m.TeamWebsiteModule)
      }
      ,
      {
        path: 'core-service',
        loadChildren: () => import('./core-service/core-service.module').then(m => m.CoreServiceModule)
      },
      {
        path: 'office-showcase',
        loadChildren: () => import('./office-showcase/office-showcase.module').then(m => m.OfficeShowcaseModule)
      },
      {
        path: 'office-core-service',
        loadChildren: () => import('./office-core-service/office-core-service.module').then(m => m.OfficeCoreServiceModule)
      },
      {
        path: 'office-websites',
        loadChildren: () => import('./office-websites/office-website.module').then(m => m.OfficeWebsiteModule)
      },
      {
        path: 'leads-crm',
        loadChildren: () => import('./leads-crm/leads-crm.module').then(m => m.LeadsCrmModule)
      }     
      
    ]
  },
  { path: 'error', component: ErrorPageComponent },
  { path: '**', redirectTo: '/portal', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true, // Keep if your application relies on hash-based routing
      preloadingStrategy: PreloadAllModules,
      canceledNavigationResolution: 'replace', // Handles canceled navigations gracefully
      paramsInheritanceStrategy: 'always', // Ensures route parameters are always inherited
      urlUpdateStrategy: 'eager', // Updates the browser URL as soon as the navigation starts
      //malformedUriErrorHandler: (error, url) => {
      //  console.warn(`Malformed URL: ${url}`, error);
      //  return { path: '/error' }; // Redirect to an error page for malformed URLs
      //},
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }

